// HubexTech talent app route as constant
const HUBEXTECH_TALENT_APP_ROUTES = {
    // Error Page route as constant
    Error_PAGE: '/*',
    // Home page route as constant
    HOME_PAGE: '/',
    // Resumes page route as constant
    RESUMES_PAGE: '/resumes/:slug',
}
export default HUBEXTECH_TALENT_APP_ROUTES